var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common_contents_wrap", attrs: { id: "links" } },
    [
      _c("h2", [_vm._v("LINKS")]),
      _vm._v(" "),
      _c("table", { staticClass: "common_table" }, [
        _c("tbody", [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("ＢＡＮＮＥＲ")]),
            _vm._v(" "),
            _c("td", [
              _c("img", {
                attrs: {
                  src: _vm.banner_image_src,
                  height: "60",
                  width: "auto",
                  alt: "ARAI'S PORTFOLIO"
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(3)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("ＳＩＴＥ　ＮＡＭＥ")]),
      _vm._v(" "),
      _c("td", [_vm._v("ＡＲＡＩ＇Ｓ　ＰＯＲＴＦＯＬＩＯ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("ＳＩＴＥ　ＵＲＬ")]),
      _vm._v(" "),
      _c("td", [_vm._v("https://arai-portfolio.firebaseapp.com")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("ＣＯＭＭＥＮＴ")]),
      _vm._v(" "),
      _c("td", [_vm._v("管理人ＡＲＡＩのポートフォリオ♪")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "link_table" }, [
      _c("tbody", [
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "https://github.com/anarai" } }, [
              _vm._v("\n\t\t\t\t\t\tＭＹ　ＧｉｔＨｕｂ\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "管理人のＧｉｔＨｕｂアカウント♪このホムペのソースもこちらから♪"
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "https://alliance7.blogspot.com/" } }, [
              _vm._v("\n\t\t\t\t\t\tＭＹ　Ｂｌｏｇ\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n\t\t\t\t\t長時間悩んだ問題について分野問わず書いています★"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t\t\tこのホムペの制作関連記事もあるよ(^_-)ー☆\n\t\t\t\t"
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "https://www.google.co.jp/" } }, [
              _vm._v("\n\t\t\t\t\t\tＧＯＯＧＬＥ\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("現在もっとも使える検索エンジン")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "https://www.yahoo.co.jp/" } }, [
              _vm._v("\n\t\t\t\t\t\tＹＡＨＯＯ！ＪＡＰＡＮ\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("いつもお世話になってます")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "a",
              {
                attrs: {
                  href: "http://bluegreen.jp/sozai/bg/texture/index.html"
                }
              },
              [_vm._v("\n\t\t\t\t\t\tフリー素材　blue-green\n\t\t\t\t\t")]
            )
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("背景画像お借りしました！お世話になってます！")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "a",
              { attrs: { href: "http://steak-french.net/sozaisyu.htm" } },
              [
                _vm._v(
                  "\n\t\t\t\t\t\tヴィラージュ・クッキング素材集\n\t\t\t\t\t"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "gifアニメと、野菜 果物 料理などの食べ物や飲み物のイラスト素材集。"
            ),
            _c("br"),
            _vm._v(
              "gif素材お借りしました！種類が豊富なのでぜひ訪問してみてください♪"
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "http://abehiroshi.la.coocan.jp/" } }, [
              _vm._v("\n\t\t\t\t\t\t阿部寛のホームページ\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "このホムペを作る時に参考にさせていただいたサイト様♪みんなの憧れ！！"
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("a", { attrs: { href: "http://verdy-kun.a-wing.biz/" } }, [
              _vm._v("\n\t\t\t\t\t\tヴェルディくんのお部屋\n\t\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "このホムペを作る時に参考にさせていただいたサイト様♪gifがイケてる！！"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }